class MobNavBack extends HTMLElement {
  constructor() {
    super();

    var wrapper = document.querySelector('.mob_nav__wrapper');

    this.addEventListener('click', function(e){
      e.preventDefault();
      var slideOut = this.closest('mob-nav-slideout');

      if (slideOut) {
        wrapper.classList.remove('overlay');
        slideOut.classList.remove('open');
      }
    });
  }
}

customElements.define("mob-nav-back", MobNavBack);